import { OverviewPage } from "@/pages/dashboard/overview/page";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_pathlessLayout/dashboard/overview")({
    validateSearch: z.object({
        matchId: z.coerce.number().optional(),
    }),
    component: OverviewPage,
});
